import { Component, computed, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { MatBadgeModule } from '@angular/material/badge';

@Component({
  selector: 'app-notifications-button',
  imports: [
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatBadgeModule,
    TranslateModule,
  ],
  templateUrl: './notifications-button.component.html',
  styleUrl: './notifications-button.component.scss'
})

export class NotificationsButtonComponent {
  public readonly badge = computed(() => (this.notificationsCount() > 0) ? this.notificationsCount().toString() : '');
  private readonly notificationsCount = signal(1);
  // private readonly notificationService = inject(NotificationService);

}
